var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-modal",
    {
      attrs: {
        id: "slack-integrate-modal",
        title: _vm.$t("integrations.slackIntegration"),
        wrapClassName: "vertical-center-modal",
        visible: _vm.modalVisible,
        footer: null,
      },
      on: {
        cancel: function ($event) {
          return _vm.close()
        },
      },
    },
    [
      _c("div", { staticClass: "form-container" }, [
        _c("div", { staticClass: "slack-description-box" }, [
          _c("span", { staticClass: "slack-description-box__icon" }, [
            _c("i", { staticClass: "material-icons" }, [_vm._v("info")]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "slack-description-box__content" }, [
            _c("div", { staticClass: "slack-description-box__text" }, [
              _vm._v(
                "\n                    " +
                  _vm._s(_vm.$t("integrations.slackDescription")) +
                  "\n                "
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "slack-description-box__steps" }, [
              _c("strong", [
                _vm._v(_vm._s(_vm.$t("integrations.slackSetupTitle"))),
              ]),
              _vm._v(" "),
              _c("ol", [
                _c("li", [_vm._v(_vm._s(_vm.$t("integrations.slackStep1")))]),
                _vm._v(" "),
                _c("li", [_vm._v(_vm._s(_vm.$t("integrations.slackStep2")))]),
                _vm._v(" "),
                _c("li", [_vm._v(_vm._s(_vm.$t("integrations.slackStep3")))]),
                _vm._v(" "),
                _c("li", [_vm._v(_vm._s(_vm.$t("integrations.slackStep4")))]),
              ]),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _vm.slackChannels.length > 0
          ? _c(
              "div",
              { staticClass: "existing-channels mb-4" },
              [
                _c("div", { staticClass: "section-title" }, [
                  _vm._v(_vm._s(_vm.$t("integrations.existingChannels"))),
                ]),
                _vm._v(" "),
                _vm._l(_vm.slackChannels, function (channel) {
                  return _c(
                    "div",
                    { key: channel._id, staticClass: "channel-item" },
                    [
                      _c(
                        "div",
                        { staticClass: "channel-info" },
                        [
                          _c("span", { staticClass: "channel-name" }, [
                            _vm._v(_vm._s(channel.name)),
                          ]),
                          _vm._v(" "),
                          _c(
                            "a-tag",
                            {
                              attrs: {
                                color: channel.enabled ? "green" : "red",
                              },
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    channel.enabled
                                      ? _vm.$t("common.active")
                                      : _vm.$t("common.inactive")
                                  ) +
                                  "\n                    "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          channel.payload && channel.payload.defaultChannel
                            ? _c("span", { staticClass: "default-channel" }, [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(channel.payload.defaultChannel) +
                                    "\n                    "
                                ),
                              ])
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "channel-actions" },
                        [
                          _c("a-switch", {
                            attrs: { checked: channel.enabled },
                            on: {
                              change: function (checked) {
                                return _vm.toggleChannel(channel, checked)
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "a-button",
                            {
                              attrs: { type: "link", danger: "" },
                              on: {
                                click: function ($event) {
                                  return _vm.deleteChannelConfirm(channel)
                                },
                              },
                            },
                            [
                              _c("i", { staticClass: "material-icons" }, [
                                _vm._v("delete"),
                              ]),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]
                  )
                }),
              ],
              2
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "new-channel-form" },
          [
            _c("div", { staticClass: "section-title" }, [
              _vm._v(_vm._s(_vm.$t("integrations.createNewChannel"))),
            ]),
            _vm._v(" "),
            _c(
              "a-form",
              { attrs: { form: _vm.form, layout: "vertical" } },
              [
                _c(
                  "a-form-item",
                  { attrs: { label: _vm.$t("integrations.channelName") } },
                  [
                    _c("a-input", {
                      directives: [
                        {
                          name: "decorator",
                          rawName: "v-decorator",
                          value: [
                            "name",
                            {
                              rules: [
                                {
                                  required: true,
                                  message: _vm.$t("integrations.requiredField"),
                                },
                              ],
                            },
                          ],
                          expression:
                            "['name', { rules: [{ required: true, message: $t('integrations.requiredField') }] }]",
                        },
                      ],
                      attrs: {
                        placeholder: _vm.$t(
                          "integrations.slackChannelNamePlaceholder"
                        ),
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "a-form-item",
                  { attrs: { label: _vm.$t("integrations.slackWebhookUrl") } },
                  [
                    _c("a-input", {
                      directives: [
                        {
                          name: "decorator",
                          rawName: "v-decorator",
                          value: [
                            "webhookUrl",
                            {
                              rules: [
                                {
                                  required: true,
                                  message: _vm.$t("integrations.requiredField"),
                                },
                                {
                                  pattern: /^https:\/\/hooks\.slack\.com\//,
                                  message: _vm.$t(
                                    "integrations.slackWebhookUrlInvalid"
                                  ),
                                },
                              ],
                            },
                          ],
                          expression:
                            "['webhookUrl', { rules: [{ required: true, message: $t('integrations.requiredField') }, { pattern: /^https:\\/\\/hooks\\.slack\\.com\\//, message: $t('integrations.slackWebhookUrlInvalid') }] }]",
                        },
                      ],
                      attrs: {
                        placeholder: _vm.$t(
                          "integrations.slackWebhookUrlPlaceholder"
                        ),
                      },
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "helper-text" }, [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.$t("integrations.slackWebhookUrlHelper")) +
                          "\n                    "
                      ),
                    ]),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "a-form-item",
                  {
                    attrs: {
                      label: _vm.$t("integrations.slackDefaultChannel"),
                    },
                  },
                  [
                    _c("a-input", {
                      directives: [
                        {
                          name: "decorator",
                          rawName: "v-decorator",
                          value: ["defaultChannel"],
                          expression: "['defaultChannel']",
                        },
                      ],
                      attrs: {
                        placeholder: _vm.$t(
                          "integrations.slackDefaultChannelPlaceholder"
                        ),
                      },
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "helper-text" }, [
                      _vm._v(
                        "\n                        " +
                          _vm._s(
                            _vm.$t("integrations.slackDefaultChannelHelper")
                          ) +
                          "\n                    "
                      ),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "actions" },
        [
          _c(
            "SupsisButton",
            { attrs: { ghost: "" }, on: { click: _vm.close } },
            [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.$t("common.cancel")) +
                  "\n        "
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "SupsisButton",
            {
              attrs: { primary: "", loading: _vm.loading },
              on: { click: _vm.createChannel },
            },
            [
              _c("i", { staticClass: "material-icons" }, [_vm._v("add")]),
              _vm._v(
                "\n            " +
                  _vm._s(_vm.$t("integrations.createChannel")) +
                  "\n        "
              ),
            ]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }